import { useState, useEffect, useCallback, useRef } from 'react'; 
import { useFarol } from '../../contexts/FarolPageContext';
import { useUser } from '../../contexts/UserContext';
import { findPermission } from '../../utils/UserPermissionUtils.js';
import DateInput from '../DateInput';
import FeedbackModal from '../Modals/FeedbackModal';
import Select from 'react-select';
import dayjs from "dayjs";
import api from '../../services/api.js';
import '../../styles/TableFilter.css';
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

function FarolPageFilter() {

    const [_dates, _setDates] = useState([]);
    const [_times, _setTimes] = useState([]);

    const [_selectedDate, _setSelectedDate] = useState(null);
    const [_selectedTime, _setSelectedTime] = useState(null);

    const [_updateFilter, _setUpdateFilter] = useState(true);
    const [_updateSenario, _setUpdateSchenario] = useState(true);

    const [_hasPermission, _setHasPermission] = useState(false);

    const [_isCreating, _setCreating] = useState(false);
    const _creatingRef = useRef(false);
    const [_isDeleting, _setDeleting] = useState(false);
    const [_feedback,   _setFeedback] = useState(null);

    const { userData } = useUser();

    const {
        handleFarolTerminalModalOpen,
        setSelectedPublicationId
    } = useFarol();

    const _handleUpdateFilter = () => {
        _setUpdateFilter(!_updateFilter);
    };

    const _handleUpdateScenario = () => _setUpdateSchenario(prev => !prev);

    const fetchScenariosDates = useCallback(async () => {
        try {
            const response = await api.get('/getAllScenariosDates');

            _setDates(response.data);
            _setSelectedDate(response.data[0]);
            _handleUpdateScenario();
        }
        catch (error) {
            console.log(error);
        }
    }, []);
    // 🔴 ALTERADO: useCallback precisa de dependências
    // como você chama _handleUpdateScenario(), ele depende indiretamente de _updateSenario

    const fetchScenarioPublications = useCallback(async () => { // 🔴 ALTERADO: envolvi em useCallback

        if (!_selectedDate) return;

        try {

            const parsedDate = dayjs(
                _selectedDate,
                ["DD/MM/YY", "YYYY-MM-DDTHH:mm:ss.SSSZ"],
                true
            );

            if (!parsedDate.isValid()) {
                throw new Error("Data inválida");
            }

            const _formattedSelectedDate = parsedDate.format("YYYY-MM-DD");

            const response = await api.get(`/getScenarioPublications/${_formattedSelectedDate}`);

            if (response.data.length === 0) return;

            _setTimes(response.data.map(item => ({
                value: item.id,
                label: item.publicationHour.slice(0, 5)
            })));

            _setSelectedTime({
                value: response.data[0].id,
                label: response.data[0].publicationHour.slice(0, 5)
            });

        } catch (error) {
            console.log(error);
        }

    }, [_selectedDate]); // 🔴 ALTERADO: depende de _selectedDate

    const _backendError = (error) => error.response?.data?.error || error.message

    const handleCreateNewScenario = async () => {

        // Trava contra duplo clique: o segundo clique é ignorado enquanto o primeiro não termina.
        if (_creatingRef.current) return;
        _creatingRef.current = true;
        _setCreating(true);

        // Data local (toISOString usaria UTC e, depois das 21h, gravaria o dia seguinte).
        const now         = dayjs();
        const currentHour = now.format('HH:mm');
        const currentDate = now.format('YYYY-MM-DD');

        try {

            await api.post('/createScenario', { currentHour, currentDate });

            _setFeedback({
                type:    'success',
                title:   'Publicação criada',
                message: `Nova publicação de ${now.format('DD/MM/YYYY')} às ${currentHour} criada com sucesso.`
            });

        } catch (error) {

            _setFeedback({ type: 'error', title: 'Erro ao criar publicação', message: _backendError(error) });

        } finally {

            _creatingRef.current = false;
            _setCreating(false);
            _handleUpdateFilter();
        }
    };

    const _deleteSelectedScenario = async () => {

        _setDeleting(true);

        try {

            await api.delete(`/deleteScenario/${_selectedTime.value}`)
            _setFeedback(null)

        } catch (error) {

            _setFeedback({ type: 'error', title: 'Erro ao excluir publicação', message: _backendError(error) });

        } finally {

            _setDeleting(false);
            _handleUpdateFilter()
        }
    }

    const handleDeleteScenario = () => {

        if (!_selectedTime) return;

        const parsedDate = dayjs(_selectedDate, ["DD/MM/YY", "YYYY-MM-DDTHH:mm:ss.SSSZ"], true)
        const dateLabel  = parsedDate.isValid() ? ` de ${parsedDate.format('DD/MM/YYYY')}` : ''

        _setFeedback({
            type:         'confirm',
            title:        'Excluir publicação',
            message:      `Excluir a publicação${dateLabel} às ${_selectedTime.label}?\nTodos os faróis desta publicação também serão apagados.`,
            confirmLabel: 'Excluir',
            onConfirm:    _deleteSelectedScenario
        });
    }

    useEffect(() => {

        fetchScenariosDates();

    }, [_updateFilter, fetchScenariosDates]);  
    // 🔴 ALTERADO: adicionei fetchScenariosDates nas dependências

    useEffect(() => {

        fetchScenarioPublications();

    }, [_selectedDate, _updateSenario, fetchScenarioPublications]);
    // 🔴 ALTERADO: adicionei fetchScenarioPublications nas dependências

    useEffect(() => {

        if (!_selectedTime) return;

        setSelectedPublicationId(_selectedTime.value);

    }, [_selectedTime, setSelectedPublicationId]);
    // 🔴 ALTERADO: adicionei setSelectedPublicationId nas dependências

    useEffect(() => {

        const hasPermission = findPermission(userData, "Edição Dados dos Faróis");

        _setHasPermission(hasPermission);

    }, [userData]);

    return (

        <section className="w-full bg-neutro borda-cinza rounded-[7px] p-[1rem] flex justify-between items-center gap-2">

            <div className=" flex flex-row gap-2">

                <DateInput
                    selectedDateType={'day'}
                    onChange={(newValue) => _setSelectedDate(newValue)}
                    datesList={_dates}
                    defaultValue={_dates?.length ? _dates[0] : null}
                />

                <Select
                    options={_times}
                    className="basic-select"
                    classNamePrefix="select"
                    value={_selectedTime}
                    onChange={(newValue) => _setSelectedTime(newValue)}
                />

                {_hasPermission && (<>

                    <button 
                        className="btn btn-vermelho [aspect-ratio:1_/_1]"
                        onClick={() => handleDeleteScenario()}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" height="18px" data-name="Layer 1" viewBox="0 0 24 24">
                            <path d="m23,4h-6v-2c0-1.103-.897-2-2-2h-6c-1.103,0-2,.897-2,2v2H1v2h1.644l1.703,15.331c.169,1.521,1.451,2.669,2.982,2.669h9.304c1.531,0,2.813-1.147,2.981-2.669l1.703-15.331h1.682v-2Zm-14-2h6v2h-6v-2Zm8.626,19.11c-.056.507-.483.89-.994.89H7.329c-.51,0-.938-.383-.994-.89l-1.679-15.11h14.65l-1.679,15.11Zm-9.583-4.567l2.543-2.543-2.543-2.543,1.414-1.414,2.543,2.543,2.543-2.543,1.414,1.414-2.543,2.543,2.543,2.543-1.414,1.414-2.543-2.543-2.543,2.543-1.414-1.414Z"/>
                        </svg> 
                    </button>

                    <button
                        className="bg-azul-profundo-m hover:bg-azul-profundo-e btn-plus disabled:opacity-60 disabled:cursor-wait"
                        onClick={() => handleCreateNewScenario()}
                        disabled={_isCreating}
                    >

                        {_isCreating ? 'Criando...' : 'Nova Publicação'}

                        <svg xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 24 24" width="20" height="20">
                            <g id="_01_align_center" data-name="01 align center">
                                <path d="M23.124,9.879,18.538,5.293,17.124,6.707l4.262,4.263L0,11l0,2,21.446-.03-4.323,4.323,1.414,1.414,4.587-4.586A3.007,3.007,0,0,0,23.124,9.879Z" />
                            </g>
                        </svg>

                    </button>

                </>)}

            </div>

            {_hasPermission && (
                <button
                    className="bg-azul-profundo-m hover:bg-azul-profundo-e btn-plus"
                    onClick={handleFarolTerminalModalOpen}
                >

                    Inserir Novo

                </button>
            )}

            <FeedbackModal
                feedback={_feedback}
                onClose={() => _setFeedback(null)}
                isConfirming={_isDeleting}
            />

        </section>
    );
}

export default FarolPageFilter;